export { default } from './IndexPage';
